import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Editor } from 'slate-react';
import classNames from 'classnames';
import groupBy from 'lodash/groupBy';
import { window } from '../../../helpers/BrowserHelpers';
import ToolbarButton from '../../../components/ToolbarButton';
import InlineToolbar from '../../../components/InlineToolbar';
import BlockActionWrapper from './BlockActionWrapper';
import Action from './Action';
import getBlockActionButtonsFromPlugins from '../utils/getBlockActionButtonsFromPlugins';
import { shouldRootCloseNodeForEvent } from '../../utils/shouldRootClose';
import BlockActionTypes from '../../../types/BlockActionTypes';
import { EDITOR_BLOCK_ACTION_FORMAT } from '../../../types/AnalyticsTypes';
var MARGIN = 4;

var BlockAction =
/*#__PURE__*/
function (_Component) {
  _inherits(BlockAction, _Component);

  function BlockAction() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, BlockAction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BlockAction)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showBlockAction: false,
      target: null,
      toolbarStyle: {}
    });

    _defineProperty(_assertThisInitialized(_this), "blockActionRef", null);

    _defineProperty(_assertThisInitialized(_this), "toolbarRef", null);

    _defineProperty(_assertThisInitialized(_this), "onBlockActionShowChange", function (showBlockAction) {
      _this.setState({
        showBlockAction: showBlockAction,
        target: _this.props.store.getItem('target')
      });

      _this.computeToolbarStyle();
    });

    _defineProperty(_assertThisInitialized(_this), "handleWindowClick", function (event) {
      if (_this.state.showBlockAction === false) {
        if (_this.props.store.getItem('blockActionClosing')) {
          _this.props.editor.command('closeBlockAction', null);
        }

        return;
      }

      var blockActionNode = ReactDOM.findDOMNode(_this.blockActionRef); // eslint-disable-line react/no-find-dom-node

      if (shouldRootCloseNodeForEvent(event, blockActionNode)) {
        var node = _this.props.store.getItem('node');

        _this.props.editor.command('closeBlockAction', node && node.key);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var changeFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (x) {
        return x;
      };

      var _ref = arguments.length > 1 ? arguments[1] : undefined,
          type = _ref.type,
          tooltipTitle = _ref.tooltipTitle,
          doNotHighlightAndFocusOnClose = _ref.doNotHighlightAndFocusOnClose;

      var _this$props = _this.props,
          editor = _this$props.editor,
          store = _this$props.store; // we don't want the block action to close on format action

      if (type !== BlockActionTypes.FORMAT) {
        editor.command('closeBlockAction', null, doNotHighlightAndFocusOnClose);
      } else {
        editor.command('track', EDITOR_BLOCK_ACTION_FORMAT, {
          type: tooltipTitle
        });
      }

      changeFn(editor, store.getItem('node'));
    });

    _defineProperty(_assertThisInitialized(_this), "onBlockActionRef", function (ref) {
      _this.blockActionRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "onToolbarRef", function (ref) {
      _this.toolbarRef = ref;

      _this.computeToolbarStyle();
    });

    _defineProperty(_assertThisInitialized(_this), "computeToolbarStyle", function () {
      var placement = _this.props.store.getItem('placement');

      if (!['left-end', 'bottom-start'].includes(placement)) {
        throw Error("Placement ".concat(placement, " not supported, only \"left-end\" and \"bottom-start\" are."));
      }

      var target = _this.props.store.getItem('target');

      var _target$getBoundingCl = target.getBoundingClientRect(),
          wrapperX = _target$getBoundingCl.x,
          wrapperHeight = _target$getBoundingCl.height,
          wrapperRight = _target$getBoundingCl.right,
          wrapperWidth = _target$getBoundingCl.width;

      var toolbarStyle = null;

      if (placement === 'bottom-start') {
        toolbarStyle = {
          left: 0,
          top: wrapperHeight + MARGIN,
          transform: 'none'
        };
      } else {
        toolbarStyle = {
          left: -2 * MARGIN,
          transform: 'translateX(-100%)',
          top: 0
        };
      }

      if (!_this.toolbarRef || !_this.toolbarRef.inputRef) {
        _this.setState({
          toolbarStyle: toolbarStyle
        });

        return;
      }

      var domToolbar = _this.toolbarRef.inputRef.current;

      var _domToolbar$getBoundi = domToolbar.getBoundingClientRect(),
          width = _domToolbar$getBoundi.width;

      if (placement === 'bottom-start') {
        if (wrapperRight + width > window.innerWidth) {
          toolbarStyle = {
            left: wrapperWidth,
            top: wrapperHeight + MARGIN,
            transform: 'translateX(-100%)'
          };
        }
      } else {
        if (wrapperX + toolbarStyle.left < width) {
          toolbarStyle = {
            transform: 'translateY(100%)',
            bottom: 0,
            left: 0
          };
        }
      }

      _this.setState({
        toolbarStyle: toolbarStyle
      });
    });

    return _this;
  }

  _createClass(BlockAction, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.store.subscribeToItem('showBlockAction', this.onBlockActionShowChange);
      window.addEventListener('mousedown', this.handleWindowClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.store.unsubscribeFromItem('showBlockAction', this.onBlockActionShowChange);
      window.removeEventListener('mousedown', this.handleWindowClick);
    }
  }, {
    key: "renderButtons",
    value: function renderButtons(buttons) {
      var _this2 = this;

      return buttons.map(function (_ref2) {
        var id = _ref2.id,
            canApply = _ref2.canApply,
            component = _ref2.component,
            _ref2$doNotHighlightA = _ref2.doNotHighlightAndFocusOnClose,
            doNotHighlightAndFocusOnClose = _ref2$doNotHighlightA === void 0 ? false : _ref2$doNotHighlightA,
            props = _objectWithoutProperties(_ref2, ["id", "canApply", "component", "doNotHighlightAndFocusOnClose"]);

        var type = props.type,
            tooltipTitle = props.tooltipTitle,
            isActive = props.isActive;

        if (type === BlockActionTypes.SHARE) {
          return component({
            id: id
          });
        }

        var ButtonType = ToolbarButton;

        if (type === BlockActionTypes.ACTION) {
          ButtonType = Action;
        }

        return React.createElement(ButtonType, Object.assign({
          key: id,
          id: id
        }, props, {
          active: isActive && isActive(_this2.props.editor),
          onChange: function onChange(onClick) {
            return _this2.handleChange(onClick, {
              type: type,
              tooltipTitle: tooltipTitle,
              doNotHighlightAndFocusOnClose: doNotHighlightAndFocusOnClose
            });
          }
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          showBlockAction = _this$state.showBlockAction,
          target = _this$state.target,
          toolbarStyle = _this$state.toolbarStyle;
      var _this$props2 = this.props,
          editor = _this$props2.editor,
          store = _this$props2.store;

      if (!showBlockAction || !target) {
        return false;
      } // Plugins are of the form:
      // { [buttonsGroupName] : [...buttons] }


      var blockActionButtons = Object.values(getBlockActionButtonsFromPlugins(editor)).reduce(function (list, plugins) {
        return [].concat(_toConsumableArray(list), _toConsumableArray(plugins));
      }, []).filter(function (_ref3) {
        var canApply = _ref3.canApply;
        return !canApply || canApply(editor, store);
      });

      var _groupBy = groupBy(blockActionButtons, 'type'),
          actionButtons = _groupBy[BlockActionTypes.ACTION],
          shareButtons = _groupBy[BlockActionTypes.SHARE];

      return React.createElement(BlockActionWrapper, {
        onBlockActionRef: this.onBlockActionRef,
        target: target
      }, React.createElement(InlineToolbar, {
        ref: this.onToolbarRef,
        style: _objectSpread({
          bottom: 'inherit',
          flexDirection: 'column',
          padding: 0,
          minWidth: 180,
          overflow: 'hidden'
        }, toolbarStyle)
      }, actionButtons && React.createElement("div", {
        className: "flexbox width-full flexbox-column"
      }, this.renderButtons(actionButtons)), shareButtons && React.createElement("div", {
        className: classNames('flexbox width-full flexbox-column border-shade-50', {
          'border-top-small': actionButtons
        })
      }, this.renderButtons(shareButtons))));
    }
  }]);

  return BlockAction;
}(Component);

_defineProperty(BlockAction, "propTypes", {
  editor: PropTypes.instanceOf(Editor),
  store: PropTypes.shape({
    getItem: PropTypes.func,
    subscribeToItem: PropTypes.func,
    unsubscribeFromItem: PropTypes.func
  }),
  plugins: PropTypes.array
});

export { BlockAction as default };